import { Component, Input, OnInit } from '@angular/core';
import { DialogServiceCustom } from 'src/app/services/dialog-custom/dialog-custom.service';

@Component({
  selector: 'app-message-basic',
  templateUrl: './message-basic.component.html',
  styleUrls: ['./message-basic.component.scss']
})
export class MessageBasicComponent implements OnInit {
  @Input() text;
  @Input() color;
  @Input() mostrar;
  constructor(private dialogServiceCustom: DialogServiceCustom) { }

  ngOnInit() {
   
  }

  openModal(){
    var options =  {
      title: 'Conoce más sobre los métodos de abono',
      content: ''
      
    }

    this.dialogServiceCustom.open(options);
  }

}


